import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Navbar } from '@/components/Navbar';
import { BottomNav } from '@/components/BottomNav';
import { LiveChat } from '@/components/LiveChat';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import Events from '@/pages/Events';
import PublicDJs from '@/pages/PublicDJs';
import PublicDJProfile from '@/pages/PublicDJProfile';
import Tickets from '@/pages/Tickets';
import Membership from '@/pages/Membership';
import Profile from '@/pages/Profile';
import Login from '@/pages/Login';
import DJDashboard from '@/pages/DJDashboard';
import EventDetail from '@/pages/EventDetail';
import DJDetail from '@/pages/DJDetail';
import MyEvents from '@/pages/MyEvents';
import MyProfile from '@/pages/MyProfile';
import OrganizerProfile from '@/pages/OrganizerProfile';
import OrganizerEvents from '@/pages/OrganizerEvents';
import DJEvents from '@/pages/DJEvents';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminUsers from '@/pages/AdminUsers';
import AdminOrganizers from '@/pages/AdminOrganizers';
import AdminDJs from '@/pages/AdminDJs';
import AdminEvents from '@/pages/AdminEvents';
import DJApply from '@/pages/DJApply';
import DJStatus from '@/pages/DJStatus';
import OrganizerApply from '@/pages/OrganizerApply';
import OrganizerStatus from '@/pages/OrganizerStatus';
import NotFound from '@/pages/NotFound';
import '@/App.css';

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/events" element={<Events />} />
              <Route path="/djs" element={<PublicDJs />} />
              <Route path="/djs/:slug" element={<PublicDJProfile />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/my-events" element={<MyEvents />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/login" element={<Login />} />
              {/* Legacy DJ profile-setup form had no Gallery composer and did not use the
                  real /djs/apply pipeline. Redirect all DJ applicants to the canonical
                  gallery-enabled application form. */}
              <Route path="/dj-profile-setup" element={<Navigate to="/dj-application" replace />} />
              <Route path="/dj-dashboard" element={<DJDashboard />} />
              <Route path="/event/:id" element={<EventDetail />} />
              <Route path="/dj/:id" element={<DJDetail />} />
              <Route path="/account/profile" element={<MyProfile />} />
              <Route path="/organizer/profile" element={<OrganizerProfile />} />
              <Route path="/organizer/events" element={<OrganizerEvents />} />
              <Route path="/dj/events" element={<DJEvents />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/organizers" element={<AdminOrganizers />} />
              <Route path="/admin/djs" element={<AdminDJs />} />
              <Route path="/admin/events" element={<AdminEvents />} />
              <Route path="/dj-apply" element={<DJApply />} />
              {/* Canonical alias for the DJ application page. */}
              <Route path="/dj-application" element={<DJApply />} />
              {/* DJ application status page (Chunk 2; auth-gated inside the component). */}
              <Route path="/dj-status" element={<DJStatus />} />
              {/* Organizer V1 — Phase 1: application + status (auth-gated inside the component). */}
              <Route path="/organizer-apply" element={<OrganizerApply />} />
              <Route path="/organizer-status" element={<OrganizerStatus />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <BottomNav />
          <LiveChat />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
